module.exports = __webpack_public_path__ + "static/media/2SHARES-WFTM.11a9852e.png";